import React from 'react'
 

export default function NoData({module}) {
  return (
    

  <div className="flex flex-col items-center justify-center min-h-[500px] p-8 bg-gradient-to-br from-blue-50 via-red-50 to-slate-50 pt-5" style={{background: 'linear-gradient(135deg, #f0f8ff 0%, #fef7f7 50%, #f8fafc 100%)',height: '50vh', width: '100%', position: 'center', overflow: 'hidden'}}>
      {/* Custom styles for your brand colors */}
      <style jsx>{`
        .brand-blue { color: #007bff; }
        .brand-red { color: #dc1d40; }
        .brand-blue-bg { background-color: #007bff; }
        .brand-red-bg { background-color: #dc1d40; }
      `}</style>
      {/* Animated Vehicle Parts Icon */}
      <div className="relative mb-8 text-center "  >
        <div className="animate-bounce">
          <svg 
            width="80" 
            height="80" 
            viewBox="0 0 140 140" 
            className="brand-blue"
          >
            {/* Car Engine Block */}
            <rect 
              x="45" 
              y="40" 
              width="50" 
              height="35" 
              rx="4"
              fill="currentColor"
              className="animate-pulse"
            />
            
            {/* Gear/Cog */}
            <circle 
              cx="30" 
              cy="30" 
              r="12" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="3"
              className="animate-spin"
              style={{animationDuration: '4s'}}
            />
            <circle cx="30" cy="30" r="4" fill="currentColor" />
            {/* Gear teeth */}
            {[0, 60, 120, 180, 240, 300].map((angle, i) => (
              <rect
                key={i}
                x="28"
                y="16"
                width="4"
                height="6"
                fill="currentColor"
                transform={`rotate(${angle} 30 30)`}
              />
            ))}
            
            {/* Wrench */}
            <g transform="rotate(25 110 35)" className="animate-pulse">
              <rect x="105" y="32" width="20" height="6" rx="3" fill="currentColor" />
              <circle cx="108" cy="35" r="4" fill="none" stroke="currentColor" strokeWidth="2" />
            </g>
            
            {/* Car Tire */}
            <circle 
              cx="110" 
              cy="90" 
              r="18" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="4"
              className="animate-pulse"
            />
            <circle cx="110" cy="90" r="8" fill="currentColor" />
            <circle cx="110" cy="90" r="3" fill="white" />
            
            {/* Spark Plug */}
            <g className="animate-pulse">
              <rect x="25" y="85" width="4" height="25" fill="currentColor" />
              <rect x="23" y="85" width="8" height="6" fill="currentColor" />
              <circle cx="27" cy="112" r="3" fill="currentColor" />
            </g>
            
            {/* Oil Drop */}
            <path 
              d="M75 95 Q75 85 82 85 Q89 85 89 95 Q89 105 82 110 Q75 105 75 95 Z"
              fill="currentColor"
              className="animate-bounce"
              style={{animationDelay: '1s'}}
            />
            
            {/* Battery */}
            <rect x="50" y="85" width="20" height="15" rx="2" fill="currentColor" className="animate-pulse" />
            <rect x="54" y="82" width="3" height="3" fill="currentColor" />
            <rect x="63" y="82" width="3" height="3" fill="currentColor" />
          </svg>
        </div>
        
        {/* Floating particles */}
        <div className="absolute -top-3 -left-3 w-3 h-3 rounded-full animate-ping brand-blue-bg"></div>
        <div className="absolute -bottom-3 -right-3 w-2 h-2 rounded-full animate-ping brand-red-bg" style={{animationDelay: '1.5s'}}></div>
        <div className="absolute top-1/3 -right-5 w-2 h-2 rounded-full animate-ping brand-blue-bg" style={{animationDelay: '2.5s'}}></div>
        <div className="absolute bottom-1/3 -left-4 w-2 h-2 rounded-full animate-ping brand-red-bg" style={{animationDelay: '3s'}}></div>
      </div>
      
      {/* Animated Text */}
      <div className="text-center space-y-3">
        <h2 className="text-1xl font-bold mb-2 animate-fade-in brand-red" style={{animationDelay: '0.2s', fontSize: '1.2rem'}}>
          No Data Found
        </h2>
        <p className="text-lg animate-fade-in brand-red" style={{animationDelay: '0.5s', fontSize: '0.9rem'}}>
          No {module}   available
        </p>
        <div className="w-16 h-1 rounded-full mx-auto animate-fade-in" style={{animationDelay: '1s', background: 'linear-gradient(90deg, #007bff 0%, #dc1d40 100%)'}}></div>
      </div>
      
      {/* Background decorative elements */}
  
      
      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </div>
  )
}
